<template>
  <pt-work-order-detail class="pt-work-order-detail__withData"></pt-work-order-detail>
</template>

<script>
import PtWorkOrderDetail from './index'
export default {
  name: 'pt-work-order-detail__withData',
  components: {
    'pt-work-order-detail': PtWorkOrderDetail
  }
}
</script>
